import React, { useEffect } from "react";
import { LandingPage } from "./pages/LandingPage";
const GA_ID = "G-KQKQ10E4Z3";
export function App() {
  useEffect(() => {
    // ===============================
    // GOOGLE ANALYTICS
    // ===============================

    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(script);
    const inlineScript = document.createElement("script");
    inlineScript.textContent = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${GA_ID}');
    `;
    document.head.appendChild(inlineScript);

    // ===============================
    // PASAR UTMs A LINKS
    // ===============================

    const utmParams = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
    const searchParams = new URLSearchParams(window.location.search);
    const hasUtms = utmParams.some(utm => searchParams.get(utm));
    if (hasUtms) {
      const transferUtms = () => {
        document.querySelectorAll<HTMLAnchorElement>('a[href*="simpleymejor.com"]').forEach(link => {
          const url = new URL(link.href);
          utmParams.forEach(utm => {
            const value = searchParams.get(utm);
            if (value) {
              url.searchParams.set(utm, value);
            }
          });
          link.href = url.toString();
        });
      };
      transferUtms();
      setTimeout(transferUtms, 1000);
    }

    // ===============================
    // VIEW CONTENT (UNA SOLA VEZ)
    // Browser + CAPI con mismo event_id para cobertura Meta
    // ===============================

    if (!sessionStorage.getItem("view_content_sent")) {
      sessionStorage.setItem("view_content_sent", "1");
      const getCookie = (name: string) => {
        const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
        return match ? decodeURIComponent(match[2]) : undefined;
      };

      // Mismo patrón de generateEventId que CTAButton.tsx
      const generateEventId = (prefix: string) => `${prefix}-${Date.now()}-${Math.random().toString(36).substring(2, 10)}`;

      // 1 segundo para que el Pixel inicialice y escriba _fbp
      setTimeout(async () => {
        const fbp = getCookie("_fbp");
        const fbc = getCookie("_fbc");

        // UN SOLO event_id compartido entre browser y CAPI
        const eventId = generateEventId("VC");
        console.log("====================================");
        console.log("👀 VIEW CONTENT DEBUG");
        console.log("====================================");
        console.log("event_id:", eventId);
        console.log("_fbp:", fbp);
        console.log("_fbc:", fbc);

        // ── 1. Browser pixel ────────────────────────────────────
        // Necesario para que Meta calcule cobertura del evento.
        // El eventID compartido permite la deduplicación con el CAPI.
        if (typeof window !== "undefined" && (window as any).fbq) {
          (window as any).fbq("track", "ViewContent", {
            currency: "ARS",
            value: 12000
          }, {
            eventID: eventId
          });
          console.log("📡 fbq ViewContent enviado — eventID:", eventId);
        } else {
          console.warn("⚠️ fbq no disponible todavía — solo CAPI");
        }

        // ── 2. CAPI server-side con el mismo event_id ───────────
        const payload = {
          event_id: eventId,
          fbp,
          fbc,
          currency: "ARS",
          value: 12000
        };
        console.log("📦 Payload CAPI:", payload);
        try {
          const response = await fetch("https://mercadopago-her-backend.vercel.app/api/view-content", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
          });
          console.log("🌐 HTTP:", response.status);
          const text = await response.text();
          console.log("📨 Backend respondió:", text);
          if (response.ok) {
            console.log("====================================");
            console.log("✅ VIEW CONTENT OK — browser + CAPI");
            console.log("====================================");
          } else {
            console.error("❌ VIEW CONTENT RECHAZADO por el backend");
          }
        } catch (err) {
          console.error("❌ Error enviando ViewContent CAPI");
          console.error(err);
        }
      }, 1000);
    }
    return () => {
      document.head.removeChild(script);
      document.head.removeChild(inlineScript);
    };
  }, []);
  return <>
      <LandingPage data-id="element-0" />

      <a href="https://wa.me/5492966531128?text=Hola%20quiero%20información%20sobre%20el%20programa%20H.E.R." target="_blank" rel="noopener noreferrer" className="fixed bottom-5 right-5 z-50 w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-[0_0_22px_rgba(37,211,102,0.45)] border border-[#CBB183]/60" aria-label="WhatsApp" data-id="element-1">
        <svg viewBox="0 0 32 32" className="w-8 h-8 text-white" fill="currentColor" data-id="element-2">
          <path d="M16.04 3C9.42 3 4.03 8.36 4.03 14.95c0 2.11.56 4.17 1.62 5.98L4 29l8.29-1.62a12.1 12.1 0 0 0 5.75 1.46C24.66 28.84 30 23.48 30 16.89S22.66 3 16.04 3Zm0 22.85c-1.8 0-3.56-.48-5.1-1.38l-.36-.21-4.93.96.98-4.79-.24-.39a9.82 9.82 0 0 1-1.5-5.09c0-5.44 4.46-9.87 9.95-9.87s10 4.43 10 9.87-4.49 9.9-10 9.9Zm5.45-7.39c-.3-.15-1.77-.87-2.04-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.27-.47-2.42-1.49-.9-.8-1.5-1.78-1.68-2.08-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.61-.92-2.21-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.22 3.08c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.23 1.36.2 1.87.12.57-.09 1.77-.72 2.02-1.42.25-.7.25-1.3.17-1.42-.07-.13-.27-.2-.57-.35Z" data-id="element-3" />
        </svg>
      </a>
    </>;
}